import { useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { getFrameAgreementAPI } from '@/api/customerApi'
import Button from '@/components/form/Button'
import { Translation } from '@/components/i18n/Translation'
import LoaderCircle from '@/components/util/LoaderCircle'
import { getCustomerId, setFrameAgreement } from '@/ducks/customerReducer'
import useApiCaller from '@/hooks/useApiCaller'

import CreditFrameApplication from './CreditFrameApplication'
import CreditFrameApplicationList from './CreditFrameApplicationList'
import CurrentFrame from './CurrentFrame'

const TabFrameAgreement = () => {
  const dispatch = useDispatch()
  const [isApplicationOpen, setIsApplicationOpen] = useState(false)

  const customerId = useSelector(getCustomerId)

  const { callApi, isLoading } = useApiCaller({
    // @ts-ignore
    action: () => getFrameAgreementAPI(customerId),
    showProgressPopup: false,
  })

  const reload = async () => {
    const frameAgreement = await callApi()
    dispatch(setFrameAgreement(frameAgreement))
  }

  useEffect(() => {
    reload()
  }, [])

  return (
    <>
      {isLoading ? (
        <LoaderCircle />
      ) : (
        <>
          <CurrentFrame />
          {!isApplicationOpen ? (
            <>
              <CreditFrameApplicationList />

              <Button onClick={() => setIsApplicationOpen(true)}>
                <Translation id="Apply for credit" />
              </Button>
            </>
          ) : (
            <CreditFrameApplication reload={reload} close={() => setIsApplicationOpen(false)} />
          )}
        </>
      )}
    </>
  )
}

export default TabFrameAgreement
